import KendoValidator from '../KendoValidator'

let KendoValidatorInstaller = class {
    static install(Vue) {
        Vue.directive(KendoValidator.name, KendoValidator)
    }
}

export default KendoValidatorInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(KendoValidatorInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-validator-vue-wrapper/src/kendo-validator-installer/index.js